import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').constant('NETWORK_POINT_SEARCH_MODE', {
        EDIT_QUICK_FILTER: 'EDIT_QUICK_FILTER',
        DEFAULT: 'DEFAULT',
        QUICK_FILTER: 'QUICK_FILTER',
        NEW_FAVORITE: 'NEW_FAVORITE'
    });
})();
